<p-checkbox
  binary="true"
  [(ngModel)]="showGrandTotal"
  (ngModelChange)="dispatchQuoteEvents()"
  name="currency"
  inputId="currency"
>
</p-checkbox>
<label for="currency">Show Grand Total in</label>
<p-select
  [(ngModel)]="grandTotalCurrency"
  [disabled]="!showGrandTotal"
  (onChange)="dispatchQuoteEvents()"
  [options]="currencySelectList()"
  [filter]="true"
  filterBy="label, value"
>
</p-select>
<i
  class="pi pi-question-circle"
  pTooltip="Rate of Exchange as per finance.google.com"
  tooltipPosition="bottom"
  hideDelay="0"
>
</i>
<span class="margin-group" [hidden]="!showGrandTotal">
  <span class="grand-total-for">for</span>
  @for (containerName of equipment() | sortEquipment; track containerName) {
    <span class="margin-wrapper">
      <span class="margin-label">
        {{ containerName | formatContainerLabel }}
      </span>
      <input
        pInputText
        [value]="getEquipmentQuantity(containerName)"
        type="text"
        maxlength="3"
        pattern="[1-9]+[0-9]*"
        required
        title=""
        digitOnly
        (keyup)="updateValue($event, containerName)"
        class="form-control margin-input"
        data-cy="quote-margin-input"
      />
    </span>
  }
</span>
